import { SearchableDecisionInstantSearch } from '@livv/models';
import { Typography } from '@mui/material';
import { Hit } from 'instantsearch.js';
import { FC } from 'react';
import { Snippet } from 'react-instantsearch';
import { limitToTwoLinesSx } from './AnalysisList';
import { HitWithSnippetResult } from '@utils/hooks/useSnippetAnalysis';
import { sxs } from '@utils/mui/sx';

const AnalysisSnippet: FC<{
    hit: Hit<SearchableDecisionInstantSearch> & HitWithSnippetResult;
    index: number;
}> = ({ hit, index }) => {
    // eslint-disable-next-line no-underscore-dangle
    const matchedNotes = hit._snippetResult?.analyses?.filter(
        ({ fullText }) => fullText?.matchLevel !== 'none',
    );

    if (!matchedNotes?.length) {
        return null;
    }

    return (
        <Typography
            color="textPrimary"
            data-test-id="analysis-full-text"
            sx={sxs([limitToTwoLinesSx, { lineHeight: 1.25 }])}
            variant="body2"
        >
            <Snippet
                attribute={['analyses', `${index}`, 'fullText']}
                hit={{ ...hit, _snippetResult: { analyses: matchedNotes } }}
            />
        </Typography>
    );
};

export default AnalysisSnippet;
